import store from 'store';
import Abstract from './class.Abstract';
import Input from './class.Input';
import { qs } from '../dom-helpers';
import AJAX from './class.AJAX';

class Cart extends Abstract {
  constructor() {
    super();

    if (!this.isCart) return;
    this.updateTimeout = null;

    this.couponForm = qs('form.coupon-form');
    this.orderCommentsTextarea = qs('#order_comments');

    this._run();
  }

  _run() {
    try {
      this._initEvents();
    } catch (e) {
      console.error(e); // eslint-disable-line
    }
  }

  _initEvents() {
    this._initQuantityButtons();
    this._initQuantityInputs();

    if (this.couponForm) {
      this.couponForm.addEventListener('submit', (e) => this._handleCouponForm(e));
    }

    if (this.orderCommentsTextarea) {
      if (store.get(this.ORDER_COMMENTS_KEY)) {
        this.orderCommentsTextarea.value = store.get(this.ORDER_COMMENTS_KEY);
      }

      this.orderCommentsTextarea.addEventListener('focusout', (e) => this._handleOrderComments(e.target));
      this.orderCommentsTextarea.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          this._handleOrderComments(e.target);
        }
      });
    }
  }

  /* @deprecated Need to refactor and use a separate module for these elements */
  _initQuantityButtons() {
    document.addEventListener('click', (e) => {
      const node = e.target;

      if (
        !node.classList.contains('product__quantity-btn')
        || node.classList.contains('.qty')
        || !node.closest('table.woocommerce-cart-form__contents')
      ) return;

      e.preventDefault();

      const buttonType = node.classList.contains('product__quantity-btn--plus') ? 'inc' : 'dec';
      let newValue = 0;
      let input = null;

      if (buttonType === 'inc') {
        newValue = parseInt(node.previousElementSibling.children[1].value, 10) + 1;
        input = node.previousElementSibling.children[1];
      } else {
        newValue = parseInt(node.nextElementSibling.children[1].value, 10) - 1;
        if (newValue <= 0) newValue = 0;
        input = node.nextElementSibling.children[1];
      }

      input.value = newValue;
      new Input().updateInputWidth(input);

      clearTimeout(this.updateTimeout);
      this.updateTimeout = setTimeout(() => Abstract.updateCart(), 1200);
    });
  }

  _initQuantityInputs() {
    document.addEventListener('click', (e) => {
      const node = e.target;

      if (!node.classList.contains('qty') || !node.closest('table.woocommerce-cart-form__contents')) return;

      node.addEventListener('change', () => {
        setTimeout(() => Abstract.updateCart(), 1200);
      });
    });
  }

  _handleCouponForm(e) {
    e.preventDefault();

    const data = new FormData(e.target);
    const _this = this;

    AJAX.post({
      action: 'woocommerce_apply_coupon',
      data: Abstract.formDataToObject(data),
      beforeSend() {
        qs('#coupon_code', _this.couponForm).readOnly = true;
      },
      complete() {
        qs('#coupon_code', _this.couponForm).readOnly = false;
      },
      success(response) {
        const level = new RegExp(/woocommerce-error/).test(response) ? 'error' : 'success';
        const strippedMessage = response.replace(/(<([^>]+)>)/ig, '').trim();

        _this._writeStatus(level, strippedMessage);
      },
    });
  }

  _handleOrderComments(textarea) {
    store.set(this.ORDER_COMMENTS_KEY, textarea.value);
  }

  _writeStatus(level, status) {
    const formStatus = qs('.alert', this.couponForm);

    Abstract.fadeIn(formStatus);

    formStatus.classList.add(level);
    formStatus.innerText = status;

    setTimeout(() => {
      Abstract.fadeOut(formStatus);

      formStatus.classList.remove(level);
      formStatus.innerText = '';
    }, 8000);
  }
}

export default Cart;
